import {LinksTabs} from './LinksTabs'
import {useGlobalTopHotelsTab, usePopularLinksTab} from './useLinksTabs'

/**
 * Interlinking block of the Home footer
 */
export const HomeLinks = () => {
  return <LinksTabs tabs={[useGlobalTopHotelsTab(), usePopularLinksTab()]} />
}
